import classnames from 'classnames';
import qs from 'query-string';
import React, { Fragment } from 'react';
import { ButtonGroup, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { ArcaHttpClientPerson } from '../../code/ArcaHttpClientPerson';
import { ArcaHttpSystem } from '../../code/ArcaHttpSystem';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaUtil } from '../../code/ArcaUtil';
import { CalendarPanel } from '../controls/Calendar/CalendarPanel';
import { ArcaLink } from '../controls/Fields/ArcaLink';
import { MapPanel } from '../controls/Mapping/MapPanel';
import { EmailListPanel } from '../controls/Messaging/EmailListPanel';
import { AccountPanel } from '../controls/People/AccountPanel';
import { InvoicePanel } from '../controls/People/InvoicePanel';
import { PersonPanel } from '../controls/People/PersonPanel';
import { PetPanel } from '../controls/PetPanel';
import { PhotoUploadAndShowPanel } from '../controls/PhotoPanel/PhotoUploadAndShowPanel';
import { OwnerSummaryPanel } from '../controls/Planning/OwnerSummaryPanel';
import { WalkerSummaryPanel } from '../controls/Planning/WalkerSummaryPanel';
import { LoginPanel } from '../controls/Security/LoginPanel';
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';
import { CustomerStatusPanel } from '../controls/People/CustomerStatusPanel';
import { ArcaHttpClientEmail } from '../../code/ArcaHttpClientEmail';
import { ChangeLogPanel } from '../controls/People/ChangeLogPanel';
import { ArcaHttpClientCalendar } from '../../code/ArcaHttpClientCalendar';

export class PersonView extends ArcaComponent {

    constructor(props) {
        super(props);
        const values = qs.parse(this.props.location.search);

        this.state = {
            person: null,
            loading: true,
            personId: values.id,
            didChange: false,
            activeTab:  values.tab != null ? values.tab : 'Main', // 'OwnerWeekPlan', // OwnerWeekPlan Main
            timeOff: ['AM', 'Mid', 'PM'],
            visitSessions: ['AM', 'PM'],
            soloSessions: ['10:00', '11:30', '01:00', '02:30', '04:00'],
            isError: false,
            statusText: '',
            imageFolder: `hint`,

            // The keys let us refresh other panels
            accountKey: null,
            invoiceKey: null,
            emails: null,
            areMessages: false,
            buttonWidth: ArcaHttpSystem.IsSmartphone ? '115px' : '180px',
            isSmartphone: ArcaHttpSystem.IsSmartphone
        };

        ArcaHttpSystem.IsLogging = false
        ArcaHttpSystem.Log(`IsWalker: ${ArcaSecurity.IsWalker}`)
    }

    resize() {
        this.setState({
            isSmartphone: ArcaHttpSystem.IsSmartphone,
            buttonWidth: ArcaHttpSystem.IsSmartphone ? '90px' : '180px',
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    componentDidMount() {
        if (ArcaSecurity.IsLoggedIn) {
            this.GetPersonDetails();
        }
        window.addEventListener("resize", this.resize.bind(this));
    }

    GetPersonDetails() {
        if (this.state.personId !== undefined) {

            this.getMessageStatus()

            ArcaHttpClientPerson.GetAsync(
                this.state.personId,
                this.processResponse.bind(this),
                ((msg) => this.setState({
                    isError: true,
                    statusText: msg
                })));
        }
        else
            this.setState({
                isError: true,
                statusText: 'This page has not been called correctly. Please go to the home page and then try again'
            })
    }

    getMessageStatus() {
        ArcaHttpClientEmail.AreUnreadEmails(
            this.state.personId,
            ((areMessages) => this.setState({ areMessages })),
            ((msg) => ArcaHttpSystem.Log(msg))
        );
    }

    async UpdateDetails(id) {
        this.setState({
            personId: id,
        });
    }

    processResponse(person) {
        this.setState({
            person: person,
            personId: person.Id,
            loading: false,
            //activeTab: 'Main',
            imageFolder: (person.Type === 'Walker') ? 'walker' : 'hint'
        });
    }

    async emailPlannedWalks(personId) {
        await ArcaHttpClientCalendar.SendBookingSummaryAsync(
            personId,
            ((msg) => this.setState({ isError: false, statusText: msg })),
            ((msg) => this.setState({ isError: true, statusText: msg }))
        )
    }

    passwordReset(personId) {
        ArcaHttpClientPerson.PasswordResetRequest(
            personId,
            (() => this.setState({ isError: false, statusText: 'Customer will receive an email to reset the password' })),
            ((msg) => this.setState({ isError: true, statusText : msg }))
        )
    }

    toggle(tab) {
        this.setState({ activeTab: tab });
    }

    renderPerson(person) {

        let { activeTab, areMessages, buttonWidth, isSmartphone } = this.state;

        return (
            <div>
                <h1 className='centerText' id="tabelLabel">{person.FirstName} {person.LastName}</h1>

                <Nav tabs className='dg-dark'>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'Main' })}
                            onClick={() => this.toggle('Main')}>
                            {ArcaSecurity.IsAdmin
                                ? person.Type + ' Details'
                                : 'Your Details'}
                        </NavLink>
                    </NavItem>

                    {person.Type === 'Owner' && (ArcaSecurity.IsOwner || ArcaSecurity.IsAdmin)
                        ? <Fragment>
                            {person.Pets.map(pet =>
                                <NavItem key={pet.Id}>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === pet.Id })}
                                        onClick={() => this.toggle(pet.Id)}>
                                        {pet.FullName}
                                    </NavLink>
                                </NavItem>
                            )}
                        </Fragment>
                        : null}

                    {person.Type === 'Owner' && (ArcaSecurity.IsAdmin)
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'Map' })}
                                onClick={() => this.toggle('Map')}>
                                Map
                        </NavLink>
                        </NavItem>
                        : null}

                    {person.Type === 'Walker' && (ArcaSecurity.IsWalker || ArcaSecurity.IsAdmin)
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === person.Type })}
                                onClick={() => this.toggle('Group')}>
                                Days off
                            </NavLink>
                        </NavItem>
                        : null}

                    {person.Type === 'Walker' && (ArcaSecurity.IsWalker || ArcaSecurity.IsAdmin)
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'WalkerWeekPlan' })}
                                onClick={() => this.toggle('WalkerWeekPlan')}>
                                Week Plan
                            </NavLink>
                        </NavItem>
                        : null}

                    {person.State === 'Registered' && person.Type === 'Owner' && (ArcaSecurity.IsOwner || ArcaSecurity.IsAdmin)
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'OwnerWeekPlan' })}
                                onClick={() => this.toggle('OwnerWeekPlan')}>
                                Week Plan
                            </NavLink>
                        </NavItem>
                        : null}

                    {person.State === 'Registered' && person.Type === 'Owner' && ArcaSecurity.IsAdmin
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'OwnerAccount' })}
                                onClick={() => this.toggle('OwnerAccount')}>
                                Account
                            </NavLink>
                        </NavItem>
                        : null}
                    {person.State === 'Registered' && person.Type === 'Owner' && (ArcaSecurity.IsOwner || ArcaSecurity.IsAdmin)
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'OwnerInvoice' })}
                                onClick={() => this.toggle('OwnerInvoice')}>
                                Invoices
                            </NavLink>
                        </NavItem>
                        : null}

                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'UserEmail' })}
                            onClick={() => this.toggle('UserEmail')}>
                            {areMessages
                                ? '*Messages'
                                : 'Messages'
                            }
                        </NavLink>
                    </NavItem>
                    {person.Type === 'Walker' || person.Type === 'Owner'
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'HintPicture' })}
                                onClick={() => this.toggle('HintPicture')}>
                                {person.Type === 'Walker'
                                    ? 'Picture'
                                    : 'Hint Photo'}
                            </NavLink>
                        </NavItem>
                        : null}

                    {ArcaSecurity.IsAdmin
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 'ChangeLog' })}
                                onClick={() => this.toggle('ChangeLog')}>
                                {'Change Log'}
                            </NavLink>
                        </NavItem>
                        : null}

                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="Main">
                        <Row>
                            <Col>
                                <CustomerStatusPanel person={person} />
                                <div className='centerText'>
                                    <ButtonGroup className='buttonGroup'>
                                        <ArcaLink text='Edit' link={'/PersonEdit?id=' + this.state.personId} width={buttonWidth} />

                                        {person.Type === 'Owner' && (ArcaSecurity.IsOwner || ArcaSecurity.IsAdmin)
                                            ? <ArcaLink text='Add Pet' link={'/PetEdit?personid=' + this.state.personId} width={buttonWidth} />
                                            : null}

                                        {parseInt(ArcaSecurity.UserId) === this.state.personId
                                            ? <ArcaLink text='Change PW' link={'/ChangePassword'} width={buttonWidth} />
                                            : null}

                                        {ArcaSecurity.IsAdmin
                                            ? <ArcaLink
                                                onClick={() => this.passwordReset(this.state.personId)}
                                                text={isSmartphone ? 'Reset PW' : 'Reset Password'}
                                                width={buttonWidth} />
                                            : null}
                                        {person.State === 'Registered' && person.Type === 'Owner'
                                            ? <ArcaLink
                                                onClick={() => this.emailPlannedWalks(this.state.personId)}
                                                text={isSmartphone ? 'Email' : 'Email Walks'}
                                                width={buttonWidth} />
                                            : null}

                                    </ButtonGroup>
                                </div>
                                <PersonPanel person={person} />
                            </Col>
                        </Row>
                    </TabPane>
                    {person.Type === 'Owner' && (ArcaSecurity.IsOwner || ArcaSecurity.IsAdmin)
                        ? <Fragment>
                            {person.Pets.map(pet =>
                                <TabPane key={pet.Id} tabId={pet.Id} color='primary'>
                                    {activeTab === pet.Id
                                        ? <Fragment>
                                            <Row>
                                                <Col>
                                                    <PetPanel
                                                        pet={pet}
                                                        person={person}
                                                        onCalendarChange={this.UpdateDetails.bind(this, this.state.personId)} />
                                                </Col>
                                            </Row>
                                        </Fragment>
                                        : null}
                                </TabPane>
                            )}
                        </Fragment>
                        : null}

                    {person.Type === 'Owner' && (ArcaSecurity.IsWalker || ArcaSecurity.IsAdmin)
                        ? <TabPane tabId="Map">
                            {activeTab === "Map"
                                ? <Fragment>
                                    <MapPanel postcode={person.Postcode} />
                                </Fragment>
                                : null}
                        </TabPane>
                        : null}

                    {person.Type === 'Walker' && (ArcaSecurity.IsWalker || ArcaSecurity.IsAdmin)
                        ? <TabPane tabId='Group'>
                            {activeTab === "Group"
                                ? <Fragment>
                                    <h1>Holiday</h1>
                                    <CalendarPanel id={person.Id} type='Walker' sessions={this.state.timeOff} />
                                </Fragment>
                                : null}
                        </TabPane>
                        : null}

                    {person.Type === 'Owner' && (ArcaSecurity.IsOwner || ArcaSecurity.IsAdmin)
                        ? <TabPane tabId='OwnerWeekPlan'>
                            {activeTab === "OwnerWeekPlan"
                                ? <OwnerSummaryPanel ownerId={person.Id} />
                                : null}
                        </TabPane>
                        : null}

                    {person.Type === 'Owner' && ArcaSecurity.IsAdmin
                        ? <TabPane tabId='OwnerAccount'>
                            {activeTab === "OwnerAccount"
                                ? <AccountPanel ownerId={person.Id} key={this.state.accountKey} onUpdated={() => this.setState({ invoiceKey: ArcaUtil.RandomString(5) })} />
                                : null}
                        </TabPane>
                        : null}

                    {person.Type === 'Owner' || ArcaSecurity.IsAdmin
                        ? <TabPane tabId='OwnerInvoice'>
                            {activeTab === "OwnerInvoice"
                                ? <InvoicePanel ownerId={person.Id} key={this.state.invoiceKey} onUpdated={() => this.setState({ accountKey: ArcaUtil.RandomString(5) })} />
                                : null}
                        </TabPane>
                        : null}

                    <TabPane tabId='UserEmail'>
                        {activeTab === "UserEmail"
                            ? <EmailListPanel personId={person.Id} messageStatusRefresh={() => this.getMessageStatus()} />
                            : null}
                    </TabPane>

                    {person.Type === 'Walker'
                        ? <TabPane tabId='WalkerWeekPlan'>
                            {activeTab === "WalkerWeekPlan"
                                ? <WalkerSummaryPanel walkerId={person.Id} />
                                : null}
                        </TabPane>
                        : null}

                    <TabPane tabId="HintPicture">
                        {activeTab === "HintPicture"
                            ? <PhotoUploadAndShowPanel folder={person.Type === 'Walker' ? 'walker' : 'hint'} id={person.Id} />
                            : null}
                    </TabPane>

                    {ArcaSecurity.IsAdmin
                        ? <TabPane tabId="ChangeLog">
                            {activeTab === "ChangeLog"
                                ? <ChangeLogPanel personId={person.Id} />
                                : null}
                        </TabPane>
                        : null
                    }


                </TabContent>
            </div>
        );
    }

    render() {

        let { statusText, isError, personId, loading, person } = this.state;

        let content = loading
            ? <p><em>Loading...</em></p>
            : this.renderPerson(person)
        ArcaHttpSystem.Log(`Person: ${personId}`)

        return (

            <Fragment>
                <StatusBar isError={isError} message={statusText} />
                {!ArcaSecurity.IsLoggedIn
                    ? <LoginPanel
                        onLogon={(() => this.GetPersonDetails()).bind(this, personId)} />
                    : content
                }
            </Fragment>
        );
    }
}
